import React, { useEffect } from "react";
import "../styles/Home.css";

const Home = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const message ="Need Cricket ID";
  const encodedMessage = encodeURIComponent(message);
  const whatsappLink = `https://wa.me/918000047833?text=${encodedMessage}`;
  const ContactLink = `https://wa.me/918000047833?text=${encodedMessage}`;
  return (

    <div className="homepage">
      {/* Header Section */}
      <section className="hero" id="home">
        <div className="hero-content">
          <h1>
            Welcome to <span className="highlight">Mahadev Book</span>
          </h1>
          <p>India's most experienced fantasy cricket platform</p>
          <p>
          Dive into the exciting world of fantasy cricket, where every match is a chance to showcase your strategy! Whether you're just starting out or a seasoned player, explore expert tips, smart team-building tactics, and deep player insights. Turn your cricket passion into winning moves and make every game more thrilling and rewarding.
            </p>
          <div className="home-btn">
            <a
              href={ContactLink}
              target="_blank"
              rel="noopener noreferrer"
              className="contactus-button"
            >
              Contact Us @ 8888568888
            </a><br /><br />
            <a
              href={whatsappLink}
              target="_blank"
              rel="noopener noreferrer"
              className="contactus-button"
            >
              WhatsApp Us @ 8888988880
            </a>

          </div>
        </div>
        <div className="hero-image">
          <img src="home.webp" alt="Sports Equipment" />
        </div>
      </section>

      {/* Customer Support Section */}
      <section className="customer-support" id="support">
        <h3>Mahadev Book <span className="highlight">Customer Support</span></h3>
        <p>
        Have questions, feedback, or need assistance? Reach out to Mahadev Book anytime! <br />Our support team is available 24/7 to handle your queries, emergencies, or <br />complaints with prompt and reliable online service. We’re always here to help.
        </p>
        <a
          href={whatsappLink}
          target="_blank"
          rel="noopener noreferrer"
          className="contactus-button"
        >
          Contact Us @ 8888568888
        </a>

      </section>

    </div>
  );
};

export default Home;
